import { Button, Text } from '@buffer-mono/popcorn'
import { Container } from './AgencyPlanSection.style'

const AgencyPlanSection = (props: {
  ctaAction: () => void
  ctaLabel: string
}): JSX.Element => {
  const { ctaAction, ctaLabel } = props

  return (
    <Container id="agency_plan_section">
      <Text>
        Need more than 10 channels?{''}{' '}
        <Button
          id="try_agency_plan"
          variant="tertiary"
          onClick={(): void => ctaAction()}
        >
          {ctaLabel}
        </Button>
      </Text>
    </Container>
  )
}

export default AgencyPlanSection
